// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyDTtbvTdJfnvzjjjhzRSX8J1enf6XuVD7U",
    authDomain: "team-combi-app.firebaseapp.com",
    databaseURL: "https://team-combi-app-default-rtdb.firebaseio.com",
    projectId: "team-combi-app",
    storageBucket: "team-combi-app.firebasestorage.app",
    messagingSenderId: "754037570720",
    appId: "1:754037570720:web:34d5c0c0df1612a2821dc5",
    measurementId: "G-T9STK01LEF"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);